import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FastForward = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FastForward' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='9 2.059 9 8 1 2.059 1 22.059 9 16 9 22.059 22 12.059' />
  </StyledIcon>
);
